/**
 * Avalara © 2017
 * file: engines/opus_ui/src/reducers/index.js
 */

import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from './auth';
import search from './search';
import cases from './cases';

const rootReducer = combineReducers({
  routing: routerReducer,
  auth,
  search,
  cases,
});

export default rootReducer;
